import { z } from "zod";
import { RevalidationWindowV1 } from "./platform.ts";

// "Integration" routes of the Explorer API (change adopt-installation-per-customer, design D14
// item 4, spec platform-administration "[FR] Operator configuration and API credentials by the
// customer's Administrator"): the customer's Administrator configures its operators and issues its
// own API credentials, per operator, with the operator permissions `configuration.manage` and
// `credentials.manage`. Served by the `operator-auth` operator interface over the same commands,
// validation, limits and audit as the Platform routes; the bodies and answers are the Platform
// area's (`ConfigureEnvironmentRequestV1`, `PlatformEnvironmentV1`, `PlatformCredentialV1`, ...).
// An operator the caller cannot access answers `404`, one it can access without the permission
// `403 forbidden`, a deactivated one `409 operator_deactivated`.

/**
 * `PATCH /operators/{id}/environment/products/{product}`: the revalidation window of an enabled
 * product only. Enabling or disabling (the contract, set by the control plane) is not part of it:
 * a body naming `enabled` answers `403 forbidden`, as does a product that is not enabled.
 */
export const PatchProductWindowRequestV1 = z
  .object({ revalidation: RevalidationWindowV1 })
  .strict()
  .meta({ id: "PatchProductWindowRequestV1" });
export type PatchProductWindowRequestV1 = z.infer<typeof PatchProductWindowRequestV1>;
